import React, { useEffect } from 'react';

interface MetaTagsProps {
  title?: string;
  children?: React.ReactNode;
}

export const MetaTags = ({ title, children }: MetaTagsProps) => {
  useEffect(() => {
    if (!title) return;
    const prev = document.title;
    document.title = title;

    return () => {
      document.title = prev || 'ProVision';
    };
  }, [title]);

  return children;
};
